export interface IText {
    tableOfContents: string | null;
    py: string | null;
    cy: string | null;
    ratio: string | null;
    taxDomicile: string | null;
    taxId: string | null;
    assets: string | null;
    liab: string | null;
    page: string | null;
    balanceToDate: string | null;
    balanceFromDate: string | null;
    incomeFromDate: string | null;
    from: string | null;
    to: string | null;
    of: string | null;
    roundingDisclaimer: string | null;
    timeStamp: string | null;
    draftLabel: string | null;
}
